import { useTranslation } from 'react-i18next';
import Thermometer from "./Thermometer";
import TitleBar from '../utils/TitleBar.js';

function Temperature(props) {
    const { t } = useTranslation();
    const { data, data2 } = props; // data2 is for Balace-board and Heating-pad

    const bss = [];
    let ln = 3;
    const ds = (data && data.Temperatures) ? data.Temperatures : [];
    const ss = (data && data.Status) ? data.Status: [];

    if (data && data.Temperatures) {
        ln = data.Temperatures.length;
    }
    let bs = [];
    for (let i=0; i<ln; i++) {
        var tt = i<ds.length ? (ds[i]-50) : 0;
        var status = 0;
        if (i < ss.length) {
            status = ss[i];
            if (ss[i] == 2 || ss[i] == 3) {
                tt = -50;
            }
        }
        bs.push(
            <div style={{
                margin: 0,
                display: "flex",
                flexDirection: 'column',
            }}>
                <div style={{
                    width: 56,
                    height: 150,
                    display: 'flex',
                }}>
                    <Thermometer id_x={i.toString()} width={60} height={150} steps={6} minValue={-50} maxValue={100} currentValue={tt}/>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                }}>
                    <div style={{
                        color: status == 0 ? "black" : 
                            status == 1 ? "red" : "gray",
                    }}>
                        {t('temperature_sensor', {
                            num: (i+1).toString().padStart(2, '0'),
                            value: status == 2 ? t('temperature_status.removed') : 
                                   status == 3 ? t('temperature_status.disabled') : 
                                   (i<ds.length ? (ds[i]-50) : "-")
                        })}
                    </div>
                </div>
            </div>
        );
        if (bs.length >= 3) {
            bss.push(
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                }}>
                    {bs}
                </div>
            );
            bs = [];
        }
    }
    if (bs.length > 0) {
        bss.push(
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
            }}>
                {bs}
            </div>
        );
    }

    // Add balance-board and heating-pad
    const bss2 = [];
    const bss3 = [];
    if (data2) {
        bs = [];
        data2.BalanceBoardTemps.forEach((v, i) => {
            bs.push(
                <div style={{
                    margin: 0,
                    display: "flex",
                    flexDirection: 'column',
                }}>
                    <div style={{
                        width: 56,
                        height: 150,
                        display: 'flex',
                    }}>
                        <Thermometer id_x={(i+100).toString()} width={60} height={150} steps={6} minValue={-50} maxValue={100} currentValue={parseInt(v)-50}/>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}>
                        <div style={{
                            color: "black",
                        }}>
                            {t('temperature_sensor', {
                                num: (i+1).toString().padStart(2, '0'),
                                value: v-50
                            })}
                        </div>
                    </div>
                </div>
            );
            if (bs.length >= 3) {
                bss2.push(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                    }}>
                        {bs}
                    </div>
                );
                bs = [];
            }
        });
        if (bs.length > 0) {
            bss2.push(
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                }}>
                    {bs}
                </div>
            );
        }
        bs = [];
        data2.HeatingPadTemps.forEach((v, i) => {
            bs.push(
                <div style={{
                    margin: 0,
                    display: "flex",
                    flexDirection: 'column',
                }}>
                    <div style={{
                        width: 54,
                        height: 150,
                        display: 'flex',
                    }}>
                        <Thermometer id_x={(i+200).toString()} width={60} height={150} steps={6} minValue={-50} maxValue={100} currentValue={parseInt(v)-50}/>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}>
                        <div style={{
                            color: "black",
                        }}>
                            {t('temperature_sensor', {
                                num: (i+1).toString().padStart(2, '0'),
                                value: v-50
                            })}
                        </div>
                    </div>
                </div>
            );
            if (bs.length >= 3) {
                bss3.push(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                    }}>
                        {bs}
                    </div>
                );
                bs = [];
            }
        });
        if (bs.length > 0) {
            bss3.push(
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                }}>
                    {bs}
                </div>
            );
        }
    }

    return (
        <div style={{
            padding: '10px 15px'
        }}>
            <TitleBar title={t('Temperature_title')} data={data?.Temperatures} />
            <div style={{
                height: '380px',
                width: '100%',
                marginTop: '20px',
                backgroundColor: "white",
                flex: "1, 1 auto",
                display: "flex",
                flexDirection: 'row',
                padding: 0,
                overflow: "hidden",
            }} >
                <div style={{
                    width: '190px',
                    backgroundColor: "#f0f0f0",
                    flex: "1, 1 auto",
                    display: "flex",
                    flexDirection: 'column',
                    padding: 0,
                    overflow: "auto",
                    borderRadius: '10px',
                    padding: "5px"
                }} >
                    <div style={{fontSize: '12px', fontWeight: 'bold', borderBottom: '1px solid #1B8AC5', marginBottom: '6px'}}>
                        {t('Cell Temperatures')}
                    </div>
                    {bss}
                </div>
                <div style={{
                    width: '190px',
                    backgroundColor: "#f0f0f0",
                    flex: "1, 1 auto",
                    display: "flex",
                    flexDirection: 'column',
                    padding: 0,
                    overflow: "auto",
                    borderRadius: '10px',
                    margin: "0 10px",
                    padding: "5px"
                }} >
                    <div style={{fontSize: '12px', fontWeight: 'bold', borderBottom: '1px solid #1B8AC5', marginBottom: '6px'}}>
                        {t('Balance-Board Temperatures')}
                    </div>
                    {bss2}
                </div>
                <div style={{
                    width: '190px',
                    backgroundColor: "#f0f0f0",
                    flex: "1, 1 auto",
                    display: "flex",
                    flexDirection: 'column',
                    padding: 0,
                    overflow: "auto",
                    borderRadius: '10px',
                    padding: "5px"
                }} >
                    <div style={{fontSize: '12px', fontWeight: 'bold', borderBottom: '1px solid #1B8AC5', marginBottom: '6px'}}>
                        {t('Heating-Pad Temperatures')}
                    </div>
                    {bss3}
                </div>
            </div>
        </div>
    );
}

export default Temperature;